<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <setting-table></setting-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import SettingTable from './SettingTable.vue'

  export default {
    name: 'scratchcard-setting',
    components: {SettingTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/scratchcard/settings/Setting.vue